import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React, { useState, useEffect, useRef } from 'react';
import { useDashboardState, useDashboardDispatch } from './context/dashboardContext';
import Utils from '../../../../utils';
import DashboardPreview from '../../Preview/DashboardPreview/DashboardPreview';
import { toXmlBase64 } from './context/serializers';
import { selectWidget } from './context/selectors/widgetsSelector';
import domToImage from 'dom-to-image';
/** https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/ */

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}
/**
 * @param {import('./types').WidgetPreviewProps} props
 */


var WidgetPreview = function WidgetPreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      widgetId = _ref.widgetId;
  var dashboardState = useDashboardState();
  var dashboardDispatch = useDashboardDispatch();
  var previousWidget = usePrevious(selectWidget(dashboardState.content, widgetId));

  var handlePreviewCaptured = function handlePreviewCaptured(value) {
    dashboardDispatch({
      type: 'change_widget_property',
      payload: {
        widgetId: widgetId,
        propertyName: 'widgetPreview',
        value: value
      }
    });
  };

  var edmPath = dashboardState.content && Utils.path.absolute(dashboardState.content.dashboard.dtLocalDataModel.dtDiagramDatasource.src, Utils.path.getFolderPath(path));
  var widget = selectWidget(dashboardState.content, widgetId);

  var handlePreviewLoaded = function handlePreviewLoaded(_ref2) {
    var ref = _ref2.ref,
        error = _ref2.error; // in case of an error just remove the preview to use predefined widget placeholder

    if (error) {
      handlePreviewCaptured('');
      return;
    } // only capture previews when a the widget is modified or a widget does not have a preview


    if (widget.widgetPreview && (!previousWidget || widget === previousWidget || widget.id !== previousWidget.id)) return;
    domToImage.toPng(ref).then(handlePreviewCaptured).catch(function (error) {
      console.error('Something went wrong creating the preview', error);
    });
  };

  var getDasboardPreviewContent = function getDasboardPreviewContent() {
    // leave a single widget and strip preview properties
    var selectPreviewContent = {
      dashboard: _objectSpread({}, dashboardState.content.dashboard, {
        dashboardPreview: '',
        pages: [{
          elementName: 'page',
          widgets: [_objectSpread({}, widget, {
            widgetPreview: ''
          })]
        }]
      })
    };
    return toXmlBase64(selectPreviewContent);
  };

  return React.createElement(DashboardPreview, {
    workspace: workspace,
    content: getDasboardPreviewContent(),
    widgetId: widgetId,
    edmPath: edmPath,
    onLoad: handlePreviewLoaded
  });
};

export default WidgetPreview;